import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    Cart,
    invalidAddressException,
    updateCart,
    UpdateCartApiParameter,
} from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
//import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
// import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import loadCart from "@sunSource/Store/Data/NewOnePageCheckout/Carts/Handlers/LoadCart";
import loadCurrentCart from "@sunSource/Store/Data/NewOnePageCheckout/Carts/Handlers/LoadCurrentCart";
import { CustomApiHandler } from "@sunSource/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<{ taxExemptStatus: string | "", checkoutType: string }, UpdateCartApiParameter>;

export const DispatchCheckoutCustomTaxExemptStatus: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutCustomTaxExemptStatus/update",
        taxExemptStatus: props.parameter.taxExemptStatus,
    });
};

export const UpdateCart: HandlerType = async props => {
    try {
        const state = props.getState();
        const { cartId } = props.parameter.checkoutType === "normal" ? state.pages.checkoutReviewAndSubmit: state.pages.onePageCheckout;
        const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
        if (!cart) {
            throw new Error("There was no current cart and we are trying to set a shipping method on it.");
        }

        const updatedCart: Cart = {
            ...cart,
            properties: {
                taxExempted: props.parameter.taxExemptStatus
            },
            ...props.parameter,
        };

        await updateCart({ cart: updatedCart });
    } catch (error) {
        if (isApiError(error) && error.status === 400 && error.errorJson.message === invalidAddressException) {
            props.dispatch({
                type: "Components/AddressErrorModal/SetIsOpen",
                isOpen: true,
            });
            return false;
        }
        throw error;
    }
};

export const LoadCart: HandlerType = props => {
    const state = props.getState();
    const { cartId } = props.parameter.checkoutType === "normal" ? state.pages.checkoutReviewAndSubmit: state.pages.onePageCheckout;
    if (cartId) {
        props.dispatch(loadCart({ cartId, getPromotions: true }));
    } else {
        props.dispatch(loadCurrentCart({ getPromotions: true }));
    }
};


export const chain = [DispatchCheckoutCustomTaxExemptStatus];

const CheckoutCustomTaxExemptStatusHandler = createHandlerChainRunner(chain, "CustomTaxExemptStatus");
export default CheckoutCustomTaxExemptStatusHandler;
